import customers from './customers'
import plans from './plans'
import contracts from './contracts'
import invoices from './invoices'
import invoiceItems from './invoiceItems'
import entries from './entries'
import taxes from './taxes'
import taxInvoices from './taxInvoices'
import cep from './cep'
import sellers from './sellers'
import settings from './settings'
import users from './users'
import auth from './auth'
import contractTaxes from './contractTaxes'
import contractPlans from './contractPlans'
import taxInvoiceSellers from './taxInvoiceSellers'
import taxTypes from './taxTypes'
import emails from './emails'
import logs from './logs'
import auditeds from './auditeds'
import profiles from './profiles'
import functionalities from './functionalities'
import profileFunctionalities from './profileFunctionalities'
import contractEmails from './contractEmails'
import contractPlanEntries from './contractPlanEntries'
import processors from './processors'
import contractSchedules from './contractSchedules'
import penalties from './penalties'

export default {
  customers,
  plans,
  contracts,
  invoices,
  taxInvoices,
  entries,
  taxes,
  cep,
  sellers,
  settings,
  users,
  auth,
  invoiceItems,
  contractTaxes,
  contractPlans,
  taxInvoiceSellers,
  taxTypes,
  emails,
  logs,
  auditeds,
  profiles,
  functionalities,
  profileFunctionalities,
  contractEmails,
  contractPlanEntries,
  processors,
  contractSchedules,
  penalties,
}
